// extracted by mini-css-extract-plugin
export default {"root":"tm5Uk","descriptorRoot":"mbsYw","name":"kovrr","unformattedName":"Hhi6n","verified":"DEoJu"};